import { createSlice } from "@reduxjs/toolkit";
import { getFeedBatenders, getPosts, getWallpapers, getWinks } from "./thunk";

export interface IState {
  posts: any;
  isPostLoading: boolean;
  isPostSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  posts: null,
  isPostLoading: false,
  isPostSuccess: false,

  error: {},
};

const PostSlice = createSlice({
  name: "Post",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Posts
    builder.addCase(getPosts.pending, (state: IState, action: any) => {
      state.isPostLoading = true;
    });
    builder.addCase(getPosts.fulfilled, (state: IState, action: any) => {
      state.posts = action.payload.data;
      state.isPostSuccess = true;
      state.isPostLoading = false;
    });
    builder.addCase(getPosts.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isPostSuccess = false;
      state.isPostLoading = false;
    });
  },
});

const WallpaperSlice = createSlice({
  name: "Wallpaper",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Posts
    builder.addCase(getWallpapers.pending, (state: IState, action: any) => {
      state.isPostLoading = true;
    });
    builder.addCase(getWallpapers.fulfilled, (state: IState, action: any) => {
      state.posts = action.payload.data;
      state.isPostSuccess = true;
      state.isPostLoading = false;
    });
    builder.addCase(getWallpapers.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isPostSuccess = false;
      state.isPostLoading = false;
    });
  },
});

const WinkSlice = createSlice({
  name: "Wink",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Posts
    builder.addCase(getWinks.pending, (state: IState, action: any) => {
      state.isPostLoading = true;
    });
    builder.addCase(getWinks.fulfilled, (state: IState, action: any) => {
      state.posts = action.payload.data;
      state.isPostSuccess = true;
      state.isPostLoading = false;
    });
    builder.addCase(getWinks.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isPostSuccess = false;
      state.isPostLoading = false;
    });
  },
});

const FeedBatenderSlice = createSlice({
  name: "FeedBatender",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Posts
    builder.addCase(getFeedBatenders.pending, (state: IState, action: any) => {
      state.isPostLoading = true;
    });
    builder.addCase(getFeedBatenders.fulfilled, (state: IState, action: any) => {
      state.posts = action.payload.data;
      state.isPostSuccess = true;
      state.isPostLoading = false;
    });
    builder.addCase(getFeedBatenders.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isPostSuccess = false;
      state.isPostLoading = false;
    });
  },
});

export const PostReducer = PostSlice.reducer;
export const WallpaperReducer = WallpaperSlice.reducer;
export const WinkReducer = WinkSlice.reducer;
export const FeedBatenderReducer = FeedBatenderSlice.reducer;